
import {
    Flex,
    LayoutBox,
    Subsection,
} from '@bamboohr/fabric';
type SubsectionContent = {
    /** State abbreviation */
    [stateAbbr: string]: {
        /** Body content for the subsection */
        contentBody: string | React.ReactNode;
        /** Title for the subsection. Also used for the ariaLabel */
        title: string;
    }
}

/**
 * A map of state tax withholding subsection content according to the state.
 * The size of the body content is unpredictable, so as this map grows, we'll want
 * to consider refactoring each mapping into its own file to import dynamically instead.
 * 
 * Additionally, we may eventually need multiple grouped subsections, in which case we'll
 * need to work with BE to come up with a new data structure for the payload to support that.
 */
const subsectionContent: SubsectionContent = {
    'IN': {
        contentBody: <>
            {$.__("Local Indiana taxes for the current calendar year are based on your home and work counties as of January 1st.")}
        </>,
        title: $.__("Indiana County Based Taxes.")
    },
}

/**
 * A simple template component for subsections to display grouped tax withholding fields. 
 */
export function WithholdingSubsection({
    stateAbbr,
    formFields,
}: {
    /** State abbreviation. Used to find subsection content related to the State */
    stateAbbr: string;
    /** A collection of React nodes to render as form fields in this subsection */
    formFields?: React.ReactNode[];
}) {
    const { contentBody, title } = subsectionContent[stateAbbr];
    return <Subsection
        ariaLabel={ title }
        title={ title }
    >
        <Flex
            flexDirection="column"
            gap={2}
        >
            <LayoutBox>
                { contentBody }
            </LayoutBox>
            <Flex
                flexDirection="column"
                gap={2}
            >
                { formFields }
            </Flex>
        </Flex>

    </Subsection>
}